import styled from "@emotion/styled"
import Roller from "components/roller-ref/Roller"

const Root = styled(Roller)()

export default function TestimoneeRollerRef(props) {
  const data = props.content[0]?.roller_ref?.roller_ref?.[0]

  // console.log("TestimoneeRollerRef(%o)", data)
  return <Root {...data} />
}
